import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import { getGetEmployeeProfileQueryKey } from "@/generated/people/people";

/** Refetches one employee profile after any of its sections is saved. */
export function useInvalidateEmployeeProfile(
  nurseryId: string,
  userId: string,
) {
  const queryClient = useQueryClient();

  return useCallback(
    () =>
      queryClient.invalidateQueries({
        queryKey: getGetEmployeeProfileQueryKey(nurseryId, userId),
      }),
    [queryClient, nurseryId, userId],
  );
}
